import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

// default empty modul
export const DefaultEmptyModulDetail = () => {
  return (
    <div className="h-[80vh] flex items-center justify-center">
      <div className="flex flex-col items-center">
        <Icon fontSize="large">book</Icon>
        <Text variant="heading-md" className="text-center mt-8">
          Untuk memulai, pilih salah satu materi terlebih dahulu
        </Text>
        <Text color="subdued" className="text-center">
          Pastikan koneksi internet Anda aktif untuk memuat halaman ini.
        </Text>
      </div>
    </div>
  )
}
